/**
 * Design tokens del Client Portal — portados del repo legacy
 * `scouting-wizard-client-portal` (handoff de Claude Design 2026-05-07/08).
 * SW-330+331+332 reusa estos tokens en los componentes de opportunities/talents/comments.
 *
 * Estilo: Modern SaaS, neutral warm-cool, ink-black accent, Geist Sans + Geist Mono.
 * Cualquier color/tipo/spacing NUEVO se agrega acá y se referencia desde el theme MUI o
 * componentes — nunca hardcoded en estilos de componente.
 */

export const tokens = {
  color: {
    // Acento principal (links, hover, brand-aware actions)
    accent: '#1f6feb',
    accentSoft: '#eaf2ff',
    accentInk: '#fff',

    // Superficies y fondos
    bg: '#fafaf9',
    surface: '#fff',
    surface2: '#f7f7f5',

    // Texto / tinta
    ink: '#0a0a0a',
    ink2: '#1c1c1c',
    muted: '#6b6b6b',
    muted2: '#9a9a9a',

    // Bordes
    line: '#e7e5e1',
    lineSoft: '#efece6',

    // Semánticos
    pos: '#15803d',
    posSoft: '#f0f7f1',
    warn: '#b45309',
    warnSoft: '#fff7ed',
    neg: '#b42318',
    negSoft: '#fef3f2',

    // Dark surface (video modals, doc previews dark mode) — SW-140
    inkInverse: '#fff',
    overlayBg: 'rgba(15,15,15,.78)',
    darkStage: '#000',
    darkControlBg: 'rgba(255,255,255,.08)',
    darkControlBgHover: 'rgba(255,255,255,.16)',
  },

  font: {
    display: '"Geist", system-ui, -apple-system, sans-serif',
    mono: '"Geist Mono", ui-monospace, "SF Mono", monospace',
  },

  size: {
    sidebarWidth: 248,
    shellMaxWidth: 1160,
    radiusSmall: 6,
    radiusBase: 9,
    radiusMedium: 11,
    radiusLarge: 16,
    radiusXLarge: 18,
    radiusPill: 999,
  },

  brand: {
    fallback: 'linear-gradient(140deg, #0f766e, #134e4a)',
  },
} as const;
